import axios from "axios";
import { AddTerm } from "./TermModal";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import React, { useState, useEffect } from "react";
import DataLoader from "../../../Utils/DataLoader";
import { HTTPURL } from "../../../constants/Matcher";
import { get_terms_by_year } from "../../../apis/Common";
import CustomTableWithChild from "../CustomTableWithChild";
import { getUserPermission } from "../../../Utils/Utils";
import { courses_all_data, course_destroy, course_copy_year } from "../../../apis/Course";
const AllCourses = () => {
  const [showResults, setShowResults] = useState(false);
  const [Course, setCourse] = useState([]);
  const [years, setYears] = useState([]);
  const [copyFrom, setCopyFrom] = useState("");
  const [copying, setCopying] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [allTerms, setAllTerms] = useState([]);
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [selectedTerms, setSelectedTerms] = useState([]);
  const permissions = getUserPermission("Course");
  const UserID = JSON.parse(localStorage.getItem("userData"))?.data?.id;
  // A course is its year, year level and course type; the name shown
  // elsewhere ("Y7 Maths", "Y7/8 Maths" in Term 4) is made from those.
  const columns2 = [
    {
      name: "Year",
      selector: "year",
      sortable: true,
    },
    {
      name: "Grade",
      selector: "grade",
      sortable: true,
    },
    {
      name: "Course Type",
      selector: "course_type_name",
      sortable: true,
    },
    {
      name: "Status",
      selector: "status",
      sortable: true,
    },
    permissions?.edit === 1 || permissions?.delete === 1
      ? {
          name: "Action",
          selector: "action",
        }
      : "",
  ];
  const handleDeleteTerm = async (courseId, termId) => {
    try {
      let responseData = await axios({
        method: "GET",
        url:
          HTTPURL + `api/course-term-distroy?term_id=${termId}&id=${courseId}`,
      });

      get_data();
      if (responseData.status) {
        toast.success(responseData?.message);
      } else {
        toast.error(responseData?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message);
    }
  };

  let childColumns = [
    {
      name: "S.No",
      selector: (_, index) => index + 1,
      sortable: true,
    },
    {
      name: "Term",
      selector: (row) => row.name,
      sortable: true,
    },
    permissions?.edit === 1 || permissions?.delete === 1
      ? {
          name: "Action",
          name: "Action",
          cell: (row) => {
            return (
              <div data-tag="allowRowEvents">
                {permissions?.edit === 1 ? (
                  <Link
                    class="edit-btn"
                    to={`/admin/course-managment/course/edit/${row.course_id}/${row.id}/${row.course_type_id}/${row?.grade_id}/${row?.year}`}
                    state={{
                      currentStepActive: 2,
                      isNotVisibleFirstStep: true,
                    }}
                  >
                    <i class="fa fa-pencil" aria-hidden="true"></i>
                  </Link>
                ) : (
                  ""
                )}
                {permissions?.delete === 1 ? (
                  <button
                    class="dlt-btn"
                    onClick={() => {
                      handleDeleteTerm(row.course_id, row.id);
                    }}
                  >
                    {" "}
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </button>
                ) : (
                  ""
                )}
              </div>
            );
          },
          ignoreRowClick: true,
          allowOverflow: true,
          button: true,
        }
      : "",
  ];

  const get_data = async () => {
    const result = await courses_all_data();
    // Newest year first, then year level, then course type.
    const sorted = (result?.data || []).slice().sort((a, b) => {
      const ay = Number(a.year) || 0;
      const by = Number(b.year) || 0;
      if (ay !== by) return by - ay;
      const ag = Number(a.grade) || 0;
      const bg = Number(b.grade) || 0;
      if (ag !== bg) return ag - bg;
      return String(a.category_name || "").localeCompare(String(b.category_name || ""));
    });
    const yearList = [...new Set(sorted.map((c) => Number(c.year)).filter(Boolean))];
    setYears(yearList);
    setCopyFrom((prev) => prev || String(yearList[0] || ""));
    const arrayData = sorted.map((elem, index) => {
      const { id, name, status, year, grade, terms, course_type, category_name } =
        elem;
      return {
        name: name,
        course_type_name: category_name,
        status_data: status,
        status: status == "0" ? "INACTIVE" : "ACTIVE",
        year: year,
        grade: grade,
        terms: terms,
        action: (
          <div data-tag="allowRowEvents">
            {permissions?.edit === 1 ? (
              <Link
                class="edit-btn"
                to={`/admin/course-managment/course/edits/${id}`}
                state={{
                  currentStepActive: 1,
                  isNotVisibleSecondStep: true,
                }}
              >
                <i class="fa fa-pencil" aria-hidden="true"></i>
              </Link>
            ) : (
              ""
            )}
            {permissions?.delete === 1 ? (
              <button
                class="dlt-btn"
                onClick={() => destroy(id, status == "1" ? 0 : 1, name)}
              >
                {" "}
                {status == 0 ? (
                  <i class="fa-solid fa-xmark"></i>
                ) : (
                  <i class="fa fa-trash" aria-hidden="true"></i>
                )}
              </button>
            ) : (
              ""
            )}
            {permissions?.add === 1 ? (
              <button
                class="dlt-btn term-add"
                onClick={() => {
                  handleAddTermClick(id, terms, course_type, year);
                }}
              >
                {" "}
                Add Term
              </button>
            ) : (
              ""
            )}
          </div>
        ),
      };
    });

    setCourse(arrayData, setShowResults(true));
  };
  const destroy = async (id, status, name) => {
    const data = { status: status, title: name, deleted_by: UserID };
    const result = window.confirm(
      `${
        status === 1
          ? "Are you sure you want to delete  this Course ?"
          : "Are you sure you want to  delete  this Course ? "
      }`
    );
    if (result) {
      await course_destroy(id, data);
    }
    get_data();
  };
  useEffect(() => {
    localStorage.removeItem("CourseEditType");
    get_data();
  }, []);

  // Copy every active course of one year to the next, then (if confirmed)
  // make the older years inactive. Running it again only adds what is
  // missing, e.g. terms of the new year that were not set up the first time.
  const copyYear = async () => {
    const from = Number(copyFrom);
    if (!from || copying) return;
    const to = from + 1;
    if (!window.confirm(`Copy all active ${from} courses to ${to}?\n\nFees, units, homework, videos and tests are copied term by term. Classes are not copied.`)) return;
    const deactivate = window.confirm(
      `Make all courses before ${to} inactive?\n\nOnly ${to} courses will stay active. Inactive courses are not offered for new enrolments or new classes, so do this once the ${from} classes have finished.\n\nOK = make them inactive, Cancel = leave them active.`
    );
    setCopying(true);
    const r = await course_copy_year(from, deactivate);
    setCopying(false);
    if (!r?.status) return;
    const d = r.data || {};
    const lines = [
      `${d.courses_created} course(s) created for ${to}` +
        (d.courses_already_there ? `, ${d.courses_already_there} already there` : "") + ".",
    ];
    if (d.terms_not_set_up?.length) {
      lines.push(
        `Term ${d.terms_not_set_up.join(", ")} of ${to} is not set up yet, so those units were not copied. ` +
          `After adding the term(s), copy ${from} again: only the missing parts are added.`
      );
    }
    if (deactivate) lines.push(`${d.deactivated} older course(s) made inactive.`);
    toast.success(`Courses copied to ${to}`);
    window.alert(lines.join("\n\n"));
    get_data();
  };

  const handleAddTermClick = async (
    id,
    alreadySelectedTerms,
    course_type,
    year
  ) => {
    setIsModalOpen(true);
    setSelectedCourseId(id);
    setSelectedTerms(alreadySelectedTerms);
    localStorage.setItem("selected_courseType_id", course_type);
    if (allTerms.length === 0) {
      const terms = await get_terms_by_year(year);
      setAllTerms(terms?.data);
    }
  };
  useEffect(() => {
    localStorage.removeItem("homeWorkData");
    localStorage.removeItem("selfStudyData");
    localStorage.removeItem("lecthureData");
    localStorage.removeItem("course_id");
    localStorage.removeItem("term_id");
  }, []);
  return (
    <>
      <div className="right-nav" id="dash-event">
        {showResults ? (
          <>
            <div className="row">
              <div className="col-md-4">
                <h4 className="modal-title">Course List</h4>
              </div>
              <div className="col-md-8">
                {permissions?.add === 1 ? (
                  <>
                    <Link
                      className="ui button float-end"
                      to="/admin/course-managment/course/add"
                    >
                      Add Course
                    </Link>
                    {years.length > 0 && (
                      <div
                        className="float-end"
                        style={{ display: "flex", alignItems: "center", gap: 8, marginRight: 12 }}
                      >
                        <span>Copy</span>
                        <select
                          className="form-select form-control"
                          style={{ width: 100 }}
                          value={copyFrom}
                          onChange={(e) => setCopyFrom(e.target.value)}
                        >
                          {years.map((y) => (
                            <option key={y} value={y}>
                              {y}
                            </option>
                          ))}
                        </select>
                        <span style={{ whiteSpace: "nowrap" }}>courses to {Number(copyFrom) + 1}</span>
                        <button
                          type="button"
                          className="ui button"
                          disabled={copying}
                          onClick={copyYear}
                        >
                          {copying ? "Copying…" : "Copy"}
                        </button>
                      </div>
                    )}
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
            <CustomTableWithChild
              columns={columns2}
              data={Course}
              childColumns={childColumns}
              disableInternalSort={true}
            />
          </>
        ) : (
          <DataLoader />
        )}
      </div>
      <AddTerm
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        allTerms={allTerms}
        selectedCourseId={selectedCourseId}
        selectedTerms={selectedTerms}
      />
    </>
  );
};
export default AllCourses;
